import { Component, Input, OnInit, Injector } from '@angular/core';
import { AthleteGeneralInfoItem, RecordHistoryItem, WaHelperService } from "world-archery-lib";
import { FiltersWorldRecordsService } from "../../services/filters-world-records.service";
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: "app-world-records-detail",
  templateUrl: "./world-records-detail.component.html",
  styleUrls: ["./world-records-detail.component.scss"]
})
export class WorldRecordsDetailComponent extends DrupalLangClass implements OnInit {
  @Input()
  allData: any;

  ngOnInit() { }
  constructor(
    public filter_service: FiltersWorldRecordsService,
    public helper: WaHelperService,
    injector: Injector,
  ) {
    super(injector);

  }

  getNameCountry(country: string) {
    return this.helper.getCountryNamesInfo(country).short;
  }
}
